import styled from 'styled-components'

const CustomerSelectorStyled = styled.div`
  h3 {
    white-space: nowrap;
    font-size: 1rem;
    color: var(--color-softText);
    margin-bottom: 0;
  }
  .CustomerSelector__value {
    font-size: 1.5rem;
    color: var(--color-strongText);
  }
  .DropdownArrow {
    &:after {
      border-color: var(--color-strongText) !important;
    }
  }
`
export default CustomerSelectorStyled
